module.exports = __webpack_public_path__ + "img/icon_5_58.86385415.png";